import { render, staticRenderFns } from "./mod.vue?vue&type=template&id=1bce5958&scoped=true"
import script from "./mod.vue?vue&type=script&lang=js"
export * from "./mod.vue?vue&type=script&lang=js"
import style0 from "./mod.vue?vue&type=style&index=0&id=1bce5958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce5958",
  null
  
)

export default component.exports